import React from 'react';
import i18n from 'i18n';
import styled from 'styled-components';

import Modal, { RowsContainer } from 'components/Modal';

const PrivateContentContainer = styled(RowsContainer)`
  text-align: center;
  margin-bottom: 25px;
`;

export const PrivateModal = ({ type, onClose, onConfirm }) => (
  <Modal
    id={`PrivateModal`}
    title={i18n('component.PrivateModal.Title')({ type })}
    onClose={onClose}
    contentCenter={
      <PrivateContentContainer>
        {i18n('component.PrivateModal.Content')({ type })}
      </PrivateContentContainer>
    }
    buttons={[
      {
        text: i18n('component.PrivateModal.CancelText')(),
        onClick: onClose,
        testType: 'cancel-private-button',
        id: 'private-button-cancel'
      },
      {
        text: i18n('component.PrivateModal.InstallText')(),
        onClick: onConfirm,
        highlight: true,
        testType: 'install-private-button',
        id: 'install-private-button-ok'
      }
    ]}
  />
);
